var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"copyright"},[_c('hr'),_c('p',[_vm._v("Tachi.ai Ventures © Copyright 2016-2019. All Rights Reserved.")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }